import { contextReducer } from "@/store/reducers"
import { initialState } from "@/store/state"
import { useReducer } from "react"
import { AuthContext } from "./AuthContext"

const AuthContextProvider = ({ children }: any) => {
  const [context, dispatch] = useReducer(contextReducer, initialState)
  return (
    <AuthContext.Provider value={{ context, dispatch }}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContextProvider
